export default __webpack_public_path__ + "media/zurb/img/product-innovation/opportunity-e05b20496717e4b60c57e824cef9eca7.png";